import {StyleSheet} from "aphrodite";

import {spacing} from "@khanacademy/wonder-blocks-tokens";

import {
    PADDING_TO_REVEAL_BORDER,
    PREVIEW_HEIGHT,
    PREVIEW_WIDTH,
} from "./constants.ts";

export const sharedStyles = StyleSheet.create({
    content: {
        width: "100%",
        minInlineSize: PREVIEW_WIDTH + PADDING_TO_REVEAL_BORDER,
        height: PREVIEW_HEIGHT + PADDING_TO_REVEAL_BORDER,
        minBlockSize: PREVIEW_HEIGHT + PADDING_TO_REVEAL_BORDER,
    },
    previewContainer: {
        width: "100%",
        minInlineSize: PREVIEW_WIDTH + PADDING_TO_REVEAL_BORDER,
        height: PREVIEW_HEIGHT + PADDING_TO_REVEAL_BORDER,
        minBlockSize: PREVIEW_HEIGHT + PADDING_TO_REVEAL_BORDER,
        alignItems: "center",
        justifyContent: "center",
        border: `2px dashed #E3E5E8`,
        borderRadius: 8,
    },
    imageFilenameContainer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "#F7F8FA",
        padding: spacing.medium_16,
        borderRadius: 8,
        width: "100%",
    },
    imageFilenameRow: {
        flexDirection: "row",
        alignItems: "center",
        gap: spacing.medium_16,
    },
    imageFilenameOverflow: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
});
